// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"476":"b4d1231b","498":"79cfbc5c","945":"b4d1231b","980":"b4d1231b"}[chunkId] + ".chunk.css";
};